import type { AccessContext, AccessForm, AccessPolicy, AccessPrincipal, SaveAccessPolicy } from '../models/access-control';
import { actionUrl, request } from './http';

export function getMyAccess(): Promise<AccessContext> {
  return request<AccessContext>(actionUrl('AccessControlHandler', 'GetMyAccess'), { method: 'POST' });
}

export function getAccessPolicies(): Promise<AccessPolicy[]> {
  return request<AccessPolicy[]>(actionUrl('AccessControlHandler', 'GetPolicies'), { method: 'POST' });
}

export function searchAccessPrincipals(term = ''): Promise<AccessPrincipal[]> {
  return request<AccessPrincipal[]>(actionUrl('AccessControlHandler', 'SearchPrincipals', { Term: term }), { method: 'POST' });
}

export function getAccessForms(): Promise<AccessForm[]> {
  return request<AccessForm[]>(actionUrl('AccessControlHandler', 'GetForms'), { method: 'POST' });
}

export function saveAccessPolicy(model: SaveAccessPolicy): Promise<{ ID: number; Success: boolean }> {
  return request<{ ID: number; Success: boolean }>(actionUrl('AccessControlHandler', 'SavePolicy'), { method: 'POST', body: model });
}

export function deleteAccessPolicy(id: number): Promise<void> {
  return request(actionUrl('AccessControlHandler', 'DeletePolicy', { ID: id }), { method: 'POST' });
}
